<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <yo-help class="mg-r-15" lang="fr" [dialogMsgSupplier]="null" [width]="800"></yo-help>
    </div>
  </dxi-item>

</dx-toolbar>
<ng-container *ngIf="navLinks">
<dx-tabs #tabs
         [items]="navLinks"
         [selectedItem]="navLinks[0]"
></dx-tabs>
<dx-multi-view
  [items]="navLinks"
  [(selectedItem)]="tabs.selectedItem"
  [loop]="false"
  [animationEnabled]="true"
>
  <div *dxTemplate="let tab of 'item'">
    <div *ngIf="tab.component">
      <ng-container *ngIf="dynamicInjector">
        <ng-container *ngComponentOutlet="tab.component; injector: dynamicInjector"></ng-container>
      </ng-container>
    </div>
  </div>
</dx-multi-view>
</ng-container>
<yo-regroupement-plat-errors></yo-regroupement-plat-errors>
